import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useScrollToHash } from '@/hooks/useScrollToHash';
import { injectBreadcrumbSchema, injectFaqSchema } from '@/utils/structuredData';
import { applyPageSeo } from '@/utils/seo';
import { SetupFlowProvider } from './SetupFlowContext';
import Hero from './components/Hero';
import SetupOverview from './components/SetupOverview';
import StepInstall from './components/StepInstall';
import StepConfigure from './components/StepConfigure';
import StepRun from './components/StepRun';
import RequirementsBand from './components/RequirementsBand';
import SetupFaq, { faqs } from './components/SetupFaq';

const pageTitle = 'MT5 Setup | Install & Run the XAUUSD EA | GoldEA';
const pageDescription =
  'Set up GoldEA in MetaTrader 5 — install MT5 and load the EA, configure it on the XAUUSD chart, then enable automated trading and monitor the system.';
const pageKeywords =
  'MT5 EA setup, install XAUUSD EA, MetaTrader 5 expert advisor, gold EA configuration';

export default function Mt5Setup() {
  useScrollToHash();

  useEffect(() => {
    const removeSeo = applyPageSeo({
      title: pageTitle,
      description: pageDescription,
      keywords: pageKeywords,
      path: '/mt5-setup',
    });

    const removeFaq = injectFaqSchema(faqs);
    const removeBreadcrumb = injectBreadcrumbSchema('MT5 Setup', '/mt5-setup');

    return () => {
      removeSeo();
      removeFaq();
      removeBreadcrumb();
    };
  }, []);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader current="mt5-setup" />
      <main>
        <SetupFlowProvider>
          <Hero />
          <SetupOverview />
        </SetupFlowProvider>
        <StepInstall />
        <StepConfigure />
        <StepRun />
        <RequirementsBand />
        <SetupFaq />
      </main>
      <SiteFooter current="mt5-setup" />
    </div>
  );
}